import React, { Component } from 'react'

import SeletorPerfil from './components/SeletorPerfil'

import { Field } from 'redux-form';
export default class ConvidarPerfil extends Component {

    componentDidMount() {
        this.props.listar();
    }

    render() {
        const { lista, label, name } = this.props;

        let perfis = []

        if (lista) {
            perfis = lista.slice()
        }

        return (<div>
            <Field name={name ? name : "users"} label={label ? label : "Membros"}
                perfis={perfis}
                component={SeletorPerfil} />

        </div>)
    }
}



// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/componentes/ConvidarPerfil/ConvidarPerfil.js